/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const rotateMonitoringCredentialBodyExpectedVersionExclusiveMin = 0;
export const rotateMonitoringCredentialBodyExpectedVersionMax = 9007199254740991;

export const RotateMonitoringCredentialBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(rotateMonitoringCredentialBodyExpectedVersionExclusiveMin)
    .max(rotateMonitoringCredentialBodyExpectedVersionMax),
});

export type RotateMonitoringCredentialBody = zod.input<typeof RotateMonitoringCredentialBody>;
export type RotateMonitoringCredentialBodyOutput = zod.output<
  typeof RotateMonitoringCredentialBody
>;
